<template>
    <section>
        <!-- Variant primary -->
        <o-breadcrumb variant="primary">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" href="/" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Variant secondary -->
        <o-breadcrumb variant="secondary">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" href="/" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Variant success -->
        <o-breadcrumb variant="success">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" href="/" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Variant info -->
        <o-breadcrumb variant="info">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" href="/" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Variant warning -->
        <o-breadcrumb variant="warning">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" href="/" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Variant danger -->
        <o-breadcrumb variant="danger">
            <o-breadcrumb-item label="Home" disabled />
            <o-breadcrumb-item label="Docs" href="/" />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>
    </section>
</template>
